/* ============================================================
   AYP Cart — panier client (localStorage)
   Source de vérité côté client jusqu'au checkout, où le worker
   recrée un draft order multi-lignes en RE-VALIDANT chaque prix
   auprès de FA (jamais le prix client). 100% additif : ne touche
   à aucune page existante tant que rien ne l'appelle.
   ============================================================ */
(function () {
  'use strict';

  // v2 : depuis le passage des prix en TTC (2026-09), `display_price_cents`
  // contient un montant TVA comprise. Une ligne enregistree sous v1 contenait
  // du hors taxe et serait re-interpretee comme un TTC, sous-facturant
  // l'affichage de 8,1 %. On change de cle plutot que de deviner l'ancienne base.
  var KEY = 'ayp_cart_v2';
  var MAX_ITEMS = 50;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
    emit();
  }

  function emit() {
    try {
      document.dispatchEvent(
        new CustomEvent('ayp:cart:change', { detail: { count: count(), lines: lineCount() } })
      );
    } catch (e) {}
  }

  function uid() {
    return 'it_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function get() {
    return read();
  }

  function count() {
    return read().reduce(function (n, it) {
      return n + (parseInt(it.amount, 10) || 1);
    }, 0);
  }

  function lineCount() {
    return read().length;
  }

  /* item attendu :
     { variant_id_shopify, amount, unit_price_cents, fa_variant_id, fa_group_id,
       properties:{...}, product_title, product_url, thumbnail,
       file_url, file_name, display_price } */
  function add(item) {
    var items = read();
    if (items.length >= MAX_ITEMS) return { ok: false, error: 'cart_full' };
    item.id = uid();
    item.added_at = Date.now();
    item.amount = parseInt(item.amount, 10) || 1;
    item.unit_price_cents = parseInt(item.unit_price_cents, 10) || 0;
    items.push(item);
    write(items);
    return { ok: true, id: item.id, count: count() };
  }

  function remove(id) {
    write(
      read().filter(function (it) {
        return it.id !== id;
      })
    );
  }

  /* Met à jour une ligne (fichier remplacé depuis le panier) : champs fusionnés, propriétés fusionnées. */
  function update(id, patch) {
    var items = read();
    var trouve = false;
    items.forEach(function (it) {
      if (it.id !== id) return;
      trouve = true;
      Object.keys(patch || {}).forEach(function (k) {
        if (k === 'properties') {
          it.properties = it.properties || {};
          Object.keys(patch.properties || {}).forEach(function (pk) { it.properties[pk] = patch.properties[pk]; });
        } else {
          it[k] = patch[k];
        }
      });
    });
    if (!trouve) return { ok: false, error: 'not_found' };
    write(items);
    return { ok: true };
  }

  function clear() {
    write([]);
  }

  // Idempotency key for checkout: persisted so a double-click / network retry
  // reuses the SAME key (the worker returns the same draft instead of creating
  // a duplicate). Cleared once the checkout succeeds.
  var CK_KEY = 'ayp_cart_ck';
  function checkoutKey() {
    try {
      var k = localStorage.getItem(CK_KEY);
      if (!k) {
        k = uid() + uid();
        localStorage.setItem(CK_KEY, k);
      }
      return k;
    } catch (e) {
      return uid() + uid();
    }
  }
  function clearCheckoutKey() {
    try {
      localStorage.removeItem(CK_KEY);
    } catch (e) {}
  }

  function totalCents() {
    return read().reduce(function (s, it) {
      return s + (parseInt(it.unit_price_cents, 10) || 0) * (parseInt(it.amount, 10) || 1);
    }, 0);
  }

  /* Payload exact attendu par /api/fa/draft-order-create-multi */
  function checkoutPayload() {
    return {
      items: read().map(function (it) {
        return {
          variant_id_shopify: it.variant_id_shopify,
          amount: it.amount,
          unit_price_cents: it.unit_price_cents,
          fa_variant_id: it.fa_variant_id,
          fa_group_id: it.fa_group_id,
          properties: it.properties || {},
        };
      }),
    };
  }

  window.AYPCart = {
    get: get,
    add: add,
    remove: remove,
    update: update,
    clear: clear,
    count: count,
    lineCount: lineCount,
    totalCents: totalCents,
    checkoutPayload: checkoutPayload,
    checkoutKey: checkoutKey,
    clearCheckoutKey: clearCheckoutKey,
    emit: emit,
  };

  // Multi-tab sync: if another tab changed the cart, refresh count/UI here too.
  try {
    window.addEventListener('storage', function (e) {
      if (e.key === KEY || e.key === null) emit();
    });
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', emit);
  } else {
    emit();
  }
})();
